import localStorageKey from '@/constants/localStorageKey'

export const getItemByLocalStorage = key => {
  try {
    const item = localStorage.getItem(key)
    if (item) {
      const data = JSON.parse(item)
      if (key === localStorageKey.STORE_CONFIG && !data.symbol) {
        data.symbol = ''
      }
      return data
    }
    return null
  } catch (error) {
    return null
  }
}

export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}
